<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Booker Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Surcharge</li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Surcharge <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>Set surcharge for Booker Tariff.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <div class="btn-group mb-15" role="group" aria-label="...">
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': isAirportTransfer }"
                  @click="onChangeServiceType(1)"
                >
                  Airport Transfer
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': isHourly }"
                  @click="onChangeServiceType(2)"
                >
                  Hourly
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option v-for="item in table.pageSizes" :value="item" :key="item">
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Class</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.masterClassName }}</td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToManageGeneralSurcharge"
                        class="btn btn-default --green35"
                        type="button"
                        @click="manageGeneralSurcharge(item)"
                      >
                        <span>General</span>
                      </button>
                      <button
                        v-if="isAllowToManageCancellationSurcharge"
                        class="btn btn-default --green35"
                        type="button"
                        @click="manageCancellationSurcharge(item)"
                      >
                        <span>Cancellation</span>
                      </button>
                      <button
                        v-if="isAllowToManagePeakPeriodSurcharge"
                        class="btn btn-default --green35"
                        type="button"
                        @click="managePeakPeriodSurcharge(item)"
                      >
                        <span>Peak-Period</span>
                      </button>
                      <button
                        v-if="isAllowToManageWaitingTimeSurcharge && type === 1"
                        class="btn btn-default --green35"
                        type="button"
                        @click="manageWaitingTimeSurcharge(item)"
                      >
                        <span>Waiting-Time</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <generalSurcharge :serviceType="type" v-if="isAllowToManageGeneralSurcharge" />
    <cancellationSurcharge :serviceType="type" v-if="isAllowToManageCancellationSurcharge" />
    <peakPeriodSurcharge :serviceType="type" v-if="isAllowToManagePeakPeriodSurcharge" />
    <waitingTimeSurcharge v-if="isAllowToManageWaitingTimeSurcharge" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import generalSurcharge from "@/components/master/sellingTariff/GeneralSurcharge";
import cancellationSurcharge from "@/components/master/sellingTariff/CancellationSurcharge";
import peakPeriodSurcharge from "@/components/master/sellingTariff/PeakPeriodSurcharge";
import waitingTimeSurcharge from "@/components/master/sellingTariff/WaitingTimeSurcharge";
import sellingTariffSurchargeService from "@/services/master/sellingTariff/sellingTariffSurchargeService.js";
import exchangeRateService from "@/services/master/exchangeRate/exchangeRateService.js";
import zoneService from "@/services/master/zone/zoneService.js";

export default {
  components: {
    generalSurcharge,
    cancellationSurcharge,
    peakPeriodSurcharge,
    waitingTimeSurcharge,
  },
  computed: {
    isServicesExist: function () {
      return this.allServices && this.allServices !== null;
    },
    isAllowToRead: function () {
      return (
        this.isServicesExist &&
        (this.allServices["SellingTariffGeneralSurcharge"] ||
          this.allServices["SellingTariffCancellationSurcharge"] ||
          this.allServices["SellingTariffPeakPeriodSurcharge"] ||
          this.allServices["SellingTariffWaitingTimeSurcharge"])
      );
    },
    isAllowToManageGeneralSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["SellingTariffGeneralSurcharge"].includes("Read")
      );
    },
    isAllowToManageCancellationSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["SellingTariffCancellationSurcharge"].includes("Read")
      );
    },
    isAllowToManagePeakPeriodSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["SellingTariffPeakPeriodSurcharge"].includes("Read")
      );
    },
    isAllowToManageWaitingTimeSurcharge: function () {
      return (
        this.isServicesExist &&
        this.allServices["SellingTariffWaitingTimeSurcharge"].includes("Read")
      );
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    isAirportTransfer: function() {
      return this.type === 1;
    },
    isHourly: function() {
      return this.type === 2;
    }
  },
  data() {
    return {
      validationErrors: {},
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      formatter: null,
      moneyFormat: null,
      allServices: null,
      items: [],
      currencies: [],
      zones: [],
      groupZone: [],
      isLoading: false,
      msg: "Please wait",
      type: 1,
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(publicSettings, "PageSize", 25);

    const profile = await this.$store.dispatch("user/getProfile");
    this.allServices = profile.services;

    if (this.isAllowToRead) {
      await Promise.all([
        this.getAll(),
        this.getCurrencySelection(),
        this.getAllZones(),
        this.getAllGroupZone()
      ]);
      if (this.moneyFormat) {
        this.formatter = new Intl.NumberFormat(this.moneyFormat.cultureCode, {
          style: "currency",
          currency: this.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: this.moneyFormat.numberOfDecimal,
        });
      }
    }
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-surcharge-link");
  },
  methods: {
    onChangeServiceType(value) {
      this.type = value
      this.getAll();
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async getAll() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await sellingTariffSurchargeService.getAll(filter);
        this.items = response.data.items;
        this.moneyFormat = response.data.moneyFormat;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCurrencySelection() {
      const response = await exchangeRateService.getCurrencySelection();
      if (response && Object.keys(response).length > 0) {
        this.currencies = Object.entries(response).map(([key, value]) => ({value: key, text: value}));
      }
    },
    async getAllZones() {
      this.zones = await zoneService.getAllActive();

      for (let i = 0; i < this.zones.length; i++) {
        const item = this.zones[i];
        item.label = `${item.group} ${item.name}`;
      }
    },
    async getAllGroupZone() {
      this.groupZone = await zoneService.getAllGroups();
      for (let i = 0; i < this.groupZone.length; i++) {
        const item = this.groupZone[i];
        item.label = item.name;
      }
    },
    manageGeneralSurcharge(item) {
      // publish message
      this.$eventBus.$emit(
        "initializeSellingTariffGeneralSurcharge",
        item,
        this.moneyFormat,
        this.formatter,
        this.currencies,
        this.zones,
        this.groupZone
      );
    },
    manageCancellationSurcharge(item) {
      // publish message
      this.$eventBus.$emit(
        "initializeSellingTariffCancellationSurcharge",
        item,
        this.moneyFormat,
        this.formatter
      );
    },
    managePeakPeriodSurcharge(item) {
      // publish message
      this.$eventBus.$emit(
        "initializeSellingTariffPeakPeriodSurcharge",
        item,
        this.moneyFormat,
        this.formatter,
        this.currencies,
        this.zones,
        this.groupZone
      );
    },
    manageWaitingTimeSurcharge(item) {
      // publish message
      this.$eventBus.$emit(
        "initializeSellingTariffWaitingTimeSurcharge",
        item,
        this.moneyFormat,
        this.formatter,
        this.currencies,
        this.zones
      );
    },
  },
};
</script>

<style scoped>
.detail-row td {
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/Surcharge.vue